/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Asset, Asset$inboundSchema } from "./asset.js";

export type UploadOpenAPIv3Result = {
  asset: Asset;
};

/** @internal */
export const UploadOpenAPIv3Result$inboundSchema: z.ZodMiniType<
  UploadOpenAPIv3Result,
  unknown
> = z.object({
  asset: Asset$inboundSchema,
});

export function uploadOpenAPIv3ResultFromJSON(
  jsonString: string,
): SafeParseResult<UploadOpenAPIv3Result, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UploadOpenAPIv3Result$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UploadOpenAPIv3Result' from JSON`,
  );
}
